module.exports = __webpack_public_path__ + "img/bg-card.7889b50c.png";